import React, {useEffect, useState} from "react";
import { Box, Button, Stack, Typography } from '@mui/material';
import moment from "moment";
import QRCode from 'qrcode';
import html2pdf from 'html2pdf.js'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import 'moment/locale/fr'; // Import French locale for moment.js
import { Download } from "@mui/icons-material";
import { Context } from "../../App";


export default function Billet({ billet, setLoad }) {
    const { setIsConnected } = React.useContext(Context);
    const billetRef = React.useRef(null);
    const [Qrimg, setQrImg] = useState(null);

    const handleDownloadBillet = () => {
        const element = billetRef.current;

        const opt = {
        margin: 0,
        filename: 'billet.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 3, useCORS: true }, //
        jsPDF: {
            unit: 'px',
            format: [ 800, 240 ], // Format billet
            orientation: 'landscape',
        },
        };

        html2pdf().set(opt).from(element).save();
    };

    const handleDownloadRecu = async () => {
        setLoad(true);
        fetch(`${process.env.REACT_APP_API_URL}/commandes/recu?billetId=${billet._id}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        .then(async response => {
            const token = response.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            if (response.status === 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                setIsConnected(false);
                throw new Error('Unauthorized');
            }
            
            if (!response.ok) {
                throw new Error('Failed to fetch receipt');
            }
            
            setLoad(false);
            const blob = await response.blob(); 
            const contentDisposition = response.headers.get('Content-Disposition');
            const filename = contentDisposition?.split('filename=')[1]?.replace(/"/g, '') || 'recu.pdf';

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            link.click();
            window.URL.revokeObjectURL(url);
        })
        .catch(error => {
            console.error('Error downloading receipt:', error);
            alert('Une erreur est survenue lors du téléchargement du reçu. Veuillez réessayer.');
        });
    };


    useEffect(() => {
        QRCode.toDataURL(billet.num, { width: '100px' }, (err, url) => {
        if (err) return console.error(err);
        setQrImg(url);
        });
    }, [billet.num]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column'}}>
            <Box ref={billetRef}
            sx={{ width: '800px', height: '240px', backgroundColor: '#ede5e3', display: 'flex', position: 'relative', overflow: 'hidden', 
                fontFamily: 'Montserrat, sans-serif',
            }}>
                {/* Left image */}
                <div style={{ width: '240px', height: '240px', overflow: 'hidden' }}>
                    <img
                        src={process.env.REACT_APP_API_URL + billet.event.image}
                        style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block',
                        }}
                        alt="Affiche"
                    />
                </div>


                {/* <img src={process.env.REACT_APP_API_URL.concat(billet.event.image)} alt="Affiche évènement" width={'240px'} style={{objectFit:'cover'}} /> */}

                {/* Ticket body */}
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'row', position: 'relative' }}>
                        {/* Info Section */}
                    <Box sx={{flex: 1, padding: '20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                            {/* Event type & address */}
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography fontSize={12} textTransform='uppercase' fontWeight="bold">
                                    {billet.event.type}
                                </Typography>
                                <Typography fontSize={12} fontWeight="bold" sx={{ textAlign: 'right', whiteSpace: 'pre-line' }}>
                                    {billet.event.lieu}
                                </Typography>
                            </Box>

                            {/* Title */}
                            <Typography
                            component="h1"
                            sx={{marginTop: '10px', fontSize: '38px', lineHeight: '40px', height: '80px', overflow: 'hidden', 
                            fontFamily: 'Archivo Black, sans-serif'}}>
                                {billet.event.titre}
                            </Typography>

                            {/* Footer Info */}
                            <Box sx={{position: 'absolute', display:'flex', flexDirection:'column', width:'100%', left: 0, bottom: 10}}>
                                <Typography fontWeight="bold" fontSize={12} sx={{ marginLeft: '20%', marginBlock: '10px', textTransform:'uppercase' }}>
                                    {billet.owner.nom} {billet.owner.prenom}
                                </Typography>

                                <Box sx={{ display: 'flex', justifyContent: 'space-between', px:'20px' }}>
                                    {[moment.utc(billet.event.date).format('D MMM'), billet.event.heure.replace(':', 'H'), 'prix: '+billet.price?.toFixed(2)+' €'].map((item, idx) => (
                                    <Typography
                                        key={idx}
                                        sx={{
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textTransform: 'uppercase',
                                        padding: '5px 15px',
                                        border: '1px solid black',
                                        borderRadius: '25px',
                                        }}
                                    >
                                        {item}
                                    </Typography>
                                    ))}
                                </Box>

                                <Typography sx={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'center', marginTop: '10px' }}>
                                    {billet.num}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>

                    {/* Separator */}
                    <Box
                    sx={{ width: '2px', borderLeft: '2px dashed #fff', marginX: '1px', position: 'relative',
                        '&::before, &::after': {content: '""', width: '30px', height: '30px', backgroundColor: '#fff', borderRadius: '50%', position: 'absolute', left: '-15px'},
                        '&::before': {top: '-16px'},
                        '&::after': { bottom: '-16px'},
                    }}
                    />

                    {/* QR Section */}
                    <Box
                    sx={{
                        width: '140px',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        padding: 0,
                    }}
                    >
                        {Qrimg ? <img
                            src={Qrimg}
                            alt="QR Code"
                            style={{ width: '100px', height: '100px', marginLeft: '10px' }}
                        /> : <Box sx={{width: '100px', height: '100px'}}></Box>}
                        <Box
                        sx={{
                            transform: 'rotate(-90deg)',
                            transformOrigin: 'left top',
                            fontWeight: 'bold',
                            fontSize: '10px',
                            whiteSpace: 'nowrap',
                            position: 'absolute',
                            top: '164px',
                            right: '-60px',
                            // left: '30px',
                            // width: '100px',
                        }}
                        >
                            {billet.num}
                        </Box>

                        {/* <Box
                            sx={{
                            writingMode: 'vertical-rl',
                            transform: 'rotate(180deg)',
                            fontWeight: 'bold',
                            fontSize: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                            padding: '5px',
                            }}
                        >
                            {billet.num}
                        </Box> */}
                    </Box>
                {/* </Box>  */}
            </Box>
            
            <Stack direction="row" alignItems="center" sx={{mt:1, mb:3, rowGap:2}}>
                <Button variant="clear" startIcon={<Download />}
                sx={{ alignSelf: 'end', mt: 1, mb:3, cursor: 'pointer', color: 'primary.main', textDecoration: 'underline' }}
                onClick={handleDownloadBillet}>Télécharger mon billet</Button>

                {!billet.event.isFree && <Button variant="clear" startIcon={<Download />}
                sx={{ alignSelf: 'end', mt: 1, mb:3, cursor: 'pointer', color: 'primary.main', textDecoration: 'underline' }}
                onClick={handleDownloadRecu}>Télécharger mon reçu</Button>}
            </Stack>

        </Box>
    )
}
